import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

import { Switch as AntSwitch } from 'antd';
import styled from 'styled-components'; // copy-pasted from antd, to solve TS4023 error

var Switch = styled(AntSwitch)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  &.ant-switch {\n    background-color: transparent;\n    border: 1px solid ", ";\n\n    & > .ant-switch-handle::before {\n      background-color: ", ";\n      box-shadow: none;\n      width: 16px;\n      height: 16px;\n    }\n\n    &.ant-switch-checked {\n      background-color: transparent;\n      border: 1px solid ", ";\n\n      & > .ant-switch-handle::before {\n        background-color: ", ";\n      }\n    }\n\n    &.ant-switch-small {\n      & > .ant-switch-handle::before {\n        width: 10px;\n        height: 10px;\n      }\n    }\n  }\n"])), function (props) {
  return props.theme.colors.darkGrey;
}, function (props) {
  return props.theme.colors.darkGrey;
}, function (props) {
  return props.theme.colors.primary;
}, function (props) {
  return props.theme.colors.primary;
});
export default Switch;